/** WHERE EVERY SIGNED-IN USER LANDS — one rule, one place.
 *
 *  Before this, the only user sent to the Command Center was an automotive one
 *  (`Login.jsx`, `organization_vertical === 'automotive'`). Now EVERY client
 *  user who is allowed to use the Command Center lands there, in every vertical
 *  and every client role. A user without that permission still goes to the
 *  Dashboard, and the Dashboard stays one tap away in the sidebar for everybody.
 *
 *  The super admin's landing is deliberately left exactly as it was.
 *  Demo entry pages and demo sessions have their own routes and are not touched.
 */
export const DASHBOARD = '/dashboard';
export const COMMAND_CENTER = '/command-center';

/** The same answer `useAuth().hasPermission` gives, read straight off the user
 *  object so a fresh login does not have to wait for context to catch up. */
export const canUseCommandCenter = (user) => {
    if (!user) return false;
    if (user.partner_access === true) {
        return user.feature_permissions?.view_command_center === true;
    }
    if (user.role === 'super_admin') return true;
    return user.feature_permissions?.view_command_center === true;
};

export const landingPathFor = (user) => {
    if (!user) return '/login';
    // A forced password change always comes first.
    if (user.must_change_password) return '/change-password';
    // SUPER ADMIN — unchanged on purpose.
    if (user.role === 'super_admin' && user.partner_access !== true) {
        return user.organization_vertical === 'automotive' ? COMMAND_CENTER : DASHBOARD;
    }
    return canUseCommandCenter(user) ? COMMAND_CENTER : DASHBOARD;
};

export default landingPathFor;
